module.exports = __webpack_public_path__ + "img/img132.1d5ca04e.svg";